<template>
	<section class="footer">
		<div class="container">
			<div class="row" data-aos="fade-up">
				<div class="col-lg-12 col-md-12">
					<div class="footer-about">
						<div class="pull-left" style="padding-top: 18px;">
							<a href="//itmsw.com" class="to_index">官网：http://itmsw.com</a>
							<p style="padding-top: 10px;">Copyright©2015-2019 深圳学必优教育科技有限公司 版权所有
								<a class="icp" target="_blank" href="http://www.beian.miit.gov.cn">粤ICP备11036314号</a>
							</p>
						</div>
						<div class="pull-right" style="margin-left: 50px;"><img class="qrcode" src="../../../public/img/qrcode_ms.jpg" /></div>
						<div class="logofoot pull-right" style="padding-top: 22px;padding-right: 22px;">
							<img src="@/assets/img/logo_foot_ms.png" alt="" title="" /></img>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'CommonFooter',
		methods: {
			hrefone() {
				this.$router.push({
					path: '/'
				})
			},
			hreftwo() {
				this.$router.push({
					path: '/course'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/common/Footer.scss';
</style>